import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const UpgradeModal = ({ UserDetails, currentPath }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (UserDetails.upgrade == '1' && currentPath !== "/subscribe") {
      setShowModal(true);
    }
  }, [UserDetails.upgrade, currentPath]);
  if (!showModal) return null;

  return (
    <div
      id="upgrade"
      className="modal slide show"
      role="dialog"
      tabIndex="-1"
      aria-labelledby="staticBackdrop"
      aria-modal="true"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog pt-5">
        <div className="modal-content mt-5 p-4" style={{ borderRadius: "1rem", backgroundColor:'#151719' }}>
          <div className="page-body">
            <div className="head">
              <div className="d-flex align-items-center justify-content-between mb-0">
                <h5 className="mb-0 fw-bold text-white">{UserDetails.upgrade_title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                ><FontAwesomeIcon icon={faXmark} style={{color: 'white', cursor: 'pointer', fontSize: '22px'}}/></button>
              </div>
              <hr style={{opacity: '0.1'}}/>
              <div className="p-3 border border-white my-4 rounded-3">
                <p className="mb-0 text-white">{UserDetails.upgrade_text}</p>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <div></div>
                <button
                  type="button"
                  className="btn bg-danger btn-hover-effect px-3 fw-bold text-white"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;